<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import MenuItem from './MenuItem.vue'

import type { Brand } from '@xcel-next/core/enums'
import type { ComposedMenu } from '@xcel-next/composer-schema'

const props = withDefaults(defineProps<{
  menu?: ComposedMenu,
  menuType?: 'header' | 'footer',
  menuContext?: 'burger' | 'desktop' | 'footer',
  isExtendedMainMenu?: boolean,
  brand?: Brand
}>(), {
  menu: () => [],
  menuType: 'header',
  menuContext: 'footer',
  isExtendedMainMenu: false
})

const openedMenuItem = ref('')

const isMenuContextDesktop = computed(() => props.menuContext === 'desktop')

const filteredMenuItems = computed(() => props.menu.filter(item =>
  !isMenuContextDesktop.value || !item.burgerOnly
))

const handleMouseLeave = () => {
  if (!isMenuContextDesktop.value) return
  openedMenuItem.value = ''
}

onMounted(() => {
  document.documentElement.classList.add('bx-js-loaded')
})
</script>

<template>
  <nav :class="{
         'bx-extended__navi': isExtendedMainMenu,
         [`bx-${menuType}__navi`]: !isExtendedMainMenu,
         [`bx-${menuType}__navi--${menuContext}`]: true,
         [`bx-typo--${menuContext}-navi`]: true,
       }"
       aria-label="Hauptnavigation"
       @mouseleave="handleMouseLeave">
    <div :class="{
      'bx-extended__navi-list': isExtendedMainMenu,
      'bx-extended__navi-list--level-0': isExtendedMainMenu,
      [`bx-${menuType}__navi-list`]: !isExtendedMainMenu,
      [`bx-${menuType}__navi-list--level-0`]: !isExtendedMainMenu
    }">
      <MenuItem v-for="(item) in filteredMenuItems"
                :key="item.name"
                :menu-item="item"
                :opened-menu-item="openedMenuItem"
                :level="1"
                :menu-type="menuType"
                :menu-context="menuContext"
                :brand="brand"
                @menu-item-hovered="openedMenuItem = $event" />
    </div>
  </nav>
</template>
